import BaseTypedController from "ips/ac/base/controller/BaseTypedController";
import Sorter from "sap/ui/model/Sorter";
import formatter from "ips/ac/model/formatter";
import ListHandler from "ips/ac/base/handler/ListHandler";
import { SearchField$SearchEvent } from "sap/m/SearchField";
import { ListItemBase$PressEvent } from "sap/m/ListItemBase";

/**
 * @namespace ips.ac.data.client.invitation-token
 */
export default class ClientInvitationTokenList extends BaseTypedController {

  public formatter = formatter;

  private listHandler: ListHandler;

  public onInit() {
    super.onInit();

    this.listHandler = new ListHandler(this, {
      entitySet: "ClientInvitationTokens",
      detailRoute: "client-invitation-detail",
      sorter: new Sorter("CreatedOn"),
      parameters: { $count: true },
    });
    this.listHandler.init();
  }

  public onFilterTable(oEvent: SearchField$SearchEvent) {
    this.listHandler.onFilterTable(oEvent);
  }

  public onItemPress(oEvent: ListItemBase$PressEvent) {
    this.listHandler.onItemPress(oEvent);
  }

  public onAdd() {
    this.navTo("clientcreate");
  }
}
